/**
 * T1858 — ali ima brskalnik sploh sejo, ki bi jo bilo vredno preveriti.
 *
 * JWT žetona sta v httpOnly piškotkih (T258), zato ju odjemalec ne vidi. Vidi pa
 * piškotek `csrf_token` (ne-httpOnly, Double Submit), ki ga zaledje postavi in
 * pobriše **skupaj** z `refresh_token` in z **isto** življenjsko dobo
 * (`_set_auth_cookies` / `_clear_auth_cookies` v `apps/api/v1/views/auth.py`).
 * Brez njega osvežitvenega piškotka ni, `auth/token/refresh/` pa bi vrnil 400.
 */
export const SESSION_HINT_COOKIE = 'csrf_token';

export function hasSessionCookie(): boolean {
  if (typeof document === 'undefined') return false;
  return document.cookie
    .split(';')
    .some((c) => c.trim().startsWith(`${SESSION_HINT_COOKIE}=`) && c.trim().length > SESSION_HINT_COOKIE.length + 1);
}

/**
 * Javne SPA poti, ki jih odpre **tuja** oseba brez računa (`AllowAny` na
 * zaledju) in ki prijavljenega uporabnika ne potrebujejo. Na njih se zagonsko
 * preverjanje prijave preskoči, kadar piškotka seje ni.
 *
 * Javne strani tržnice sem ne sodijo: streže jih Django (`apps/public_site`),
 * ne SPA, zato `checkAuth` tam sploh ne teče.
 */
const PUBLIC_ANONYMOUS_PREFIXES = ['/share/'];

export function isPublicAnonymousPath(pathname: string): boolean {
  return PUBLIC_ANONYMOUS_PREFIXES.some((p) => pathname.startsWith(p));
}
